var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.024,
    height: 40.024,
    viewBox: "0 0 40.024 40.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187499",
    "data-name": "Group 187499",
    transform: "translate(-325 -265.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37627",
    "data-name": "Path 37627",
    d: "M10.006,0H30.018A10.006,10.006,0,0,1,40.024,10.006V30.018A10.006,10.006,0,0,1,30.018,40.024H10.006A10.006,10.006,0,0,1,0,30.018V10.006A10.006,10.006,0,0,1,10.006,0Z",
    transform: "translate(325 265.26)",
    fill: "#fbf2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185876",
    "data-name": "Group 185876",
    transform: "translate(334.163 275.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185877",
    "data-name": "Group 185877",
    transform: "translate(0.839 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17952",
    "data-name": "Path 17952",
    d: "M20.858,5.514v.821a1.085,1.085,0,0,0-.029.132,5.894,5.894,0,0,1-1.766,3.693q-4.037,4.038-8.076,8.074a5.839,5.839,0,0,1-3.871,1.772,5.682,5.682,0,0,1-3.548-.922A5.731,5.731,0,0,1,.877,14.735,5.749,5.749,0,0,1,2.624,9.87q4.037-4.052,8.088-8.09A5.831,5.831,0,0,1,13.621.155c.3-.066.6-.105.9-.156h.821a.464.464,0,0,0,.092.027,5.721,5.721,0,0,1,2.722.933,5.77,5.77,0,0,1,2.466,3.352c.109.392.158.8.235,1.2M14.08,12.563a.556.556,0,0,0,.045-.037c1.231-1.23,2.472-2.45,3.688-3.694a4.007,4.007,0,0,0,1.054-4.067,4.093,4.093,0,0,0-6.89-1.679Q10.189,4.879,8.4,6.668c-.039.039-.074.084-.1.114l5.783,5.781M2.661,13.936a1.9,1.9,0,0,0,.014.262.406.406,0,0,0,.331.344.392.392,0,0,0,.46-.174.839.839,0,0,0,.1-.367A3.02,3.02,0,0,1,4.4,11.968c.893-.923,1.809-1.823,2.714-2.734a1.26,1.26,0,0,0,.175-.209.4.4,0,0,0,0-.443.376.376,0,0,0-.4-.218.8.8,0,0,0-.384.2q-1.317,1.3-2.617,2.609a4.091,4.091,0,0,0-1.23,2.762",
    transform: "translate(-0.839 0.001)",
    fill: "#61277f",
    stroke: "#fbf2ff",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.c8642fc85caa809abac939976597b364.svg";
export { ForwardRef as ReactComponent };